import React, { lazy, useEffect, useState, useContext } from "react";
import { CommonValidateAddress } from "./CommonValidateAddress";
import { ValidateInstallationAddress } from "./ValidateInstallationAddress";
import { EMAIL_REGEX_C360 } from "../../constants/ValidationConstants";
import { FlexRow, SmallText, SLNotification, SLGridLayout, SLRowLayout, CompactCol, UltraMediumText } from "../../components/core/utility";
import useOutsideClick from "../../customHook/use-outside-click";
import { Input, CheckboxGroup } from "@vds/inputs";
import { Button } from "@vds/buttons";
import { Title } from "@vds/typography";
import styled from "styled-components";
import { css } from "@emotion/react";
import { generate } from "shortid";
import { switchTab } from "./utils";
import { Loader } from "@vds/loaders";
import { C4SContext } from "../../context/c4sContext";
import { saveVin } from "../../services/C4S Decommission - Replacement/validateVin";
import "./AddAssetAssignment.css";

const CheckboxWrapper = styled.div`
  & label p {
    font-size: 14px !important;
    font-weight: 500 !important;
  }
`;

const HistoricalAddressRow = css`
  @media screen and (min-width: 910px) {
    width: 40%;
    max-width: 37.25rem;
    min-width: 4.125rem;
  }
`;

export const CustomInput = styled(Input)`
  padding-bottom: 0.5rem;
  height: auto;
  width: 100%;
  max-width: 100%;
  & * {
    max-width: 100%;
  }
  & label {
    & p {
      font-size: 12px;
      font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "400")};
      color: ${(props) => (props.disabled ? "#d8dada" : "")};
    }
  }
  & span {
    & span {
      & span {
        width: ${(props) => (props.boxWidth ? props.boxWidth : "")};
      }
    }
  }
  & input {
    font-size: 12px;
    height: ${(props) => (props.height ? props.height : "")};
    &:disabled {
      -webkit-text-fill-color: #000000;
      background-color: #ffffff;
      border-bottom: 1px solid #000000;
      border-top: 1px solid #dfe0e0;
      color: ${(props) => (props.disabled ? "#d8dada" : "")};
      opacity: ${(props) => (props.disabled ? "0.4" : "")};
    }
  }
  & span {
    width: ${(props) => (props.width ? props.width : "")};
    & span {
      & span {
        & div:not(:first-child) {
          & svg {
            display: none; // hide success tick icon
          }
        }
      }
    }
  }
`;
export default function AddAssetAssignment(props) {
  const { cspDetails, workTicketInfo } = useContext(C4SContext);
  const [productInfo] = useState(props.productInfo ?? []);
  const [pendingAssignment, setPendingAssignment] = useState(10);
  const [isLoading, setLoader] = useState(false);
  const [notification, setNotification] = useState(null);
  const [featureValues, setFeatureValues] = useState("");
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [vehicleSubscriptions, setVehicleSubscriptions] = useState([]);
  const [address, setAddress] = useState({
    verified: false,
    addressByPass: null,
    locationFound: null,
    timezone: "",
    latitude: "",
    longitude: "",
    locusSuggestedAddress: "",
    historicalAddress: { value: "", error: false, errorText: "", success: false },
    address1: { value: "", error: false, errorText: "Enter valid street address", success: false },
    address2: { value: "", error: false, errorText: "Enter address 2", success: false },
    city: { value: "", error: false, errorText: "Enter city", success: false },
    country: { value: null, options: [], error: false, errorText: "Please select country", success: false },
    state: { value: null, options: [], allStateOptions: null, error: false, errorText: "Please select state", success: false },
    zip: { value: "", error: false, errorText: "Enter zip code", success: false },
  });
  const [newAddress, setNewAddress] = useState({
    verified: false,
    addressByPass: null,
    locationFound: null,
    timezone: "",
    latitude: "",
    longitude: "",
    locusSuggestedAddress: "",
    historicalAddress: { value: "", error: false, errorText: "", success: false },
    address1: { value: "", error: false, errorText: "Enter valid street address", success: false },
    address2: { value: "", error: false, errorText: "Enter address 2", success: false },
    city: { value: "", error: false, errorText: "Enter city", success: false },
    country: { value: null, options: [], error: false, errorText: "Please select country", success: false },
    state: { value: null, options: [], allStateOptions: null, error: false, errorText: "Please select state", success: false },
    zip: { value: "", error: false, errorText: "Enter zip code", success: false },
  });
  const [name, setName] = useState({
    value: "",
    error: false,
    errorText: "Enter name",
    success: false,
  });
  const [phone, setPhone] = useState({
    value: "",
    error: false,
    errorText: "Enter phone",
    success: false,
  });
  const [email, setEmail] = useState({
    value: "",
    error: false,
    errorText: "Enter email",
    success: false,
  });
  const [newName, setNewName] = useState({
    value: "",
    error: false,
    errorText: "Enter name",
    success: false,
  });
  const [newPhone, setNewPhone] = useState({
    value: "",
    error: false,
    errorText: "Enter phone",
    success: false,
  });
  const [newEmail, setNewEmail] = useState({
    value: "",
    error: false,
    errorText: "Enter email",
    success: false,
  });
  const [quantity, setQuantity] = useState({
    value: "",
    error: false,
    errorText: "Enter quantity",
    success: false,
  });
  const [installType, setInstallType] = useState(null);
  const [sameAsShipping, setSameAsShipping] = useState(true);
  const formatPhoneNumber = (value) => {
    const digits = value.replace(/\D/g, "");
    if (digits.length === 0) return "";
    if (digits.length > 10) return digits;
    if (digits.length <= 3) return `(${digits}`;
    if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  };

  const handleFields = (field, value, isAutoPopulated = false) => {
    switch (field) {
      case "Name": {
        if (value && value.length) {
          setName({ value, error: false, errorText: "Enter name", success: true });
        } else {
          setName({ value: "", error: true, errorText: "Enter name", success: false });
        }
        break;
      }
      case "Phone": {
        if (isAutoPopulated) {
          if (value && value.length) {
            setPhone({ value, error: false, errorText: "Enter phone number", success: true });
          } else {
            setPhone({ value: "", error: true, errorText: "Enter phone number", success: false });
          }
        } else {
          const isIntlFormat = value.startsWith("+");
          if (isIntlFormat) {
            const rawDigits = value.replace(/[^0-9]/g, "");
            if (rawDigits.length === 0) {
              setPhone({ value: "+", error: true, errorText: "Enter +1 followed by 10 digits", success: false });
            } else {
              const forced = "1" + rawDigits.replace(/^1/, "");
              const cleaned = "+" + forced;
              const phoneDigits = forced.slice(1);
              if (phoneDigits.length === 10) {
                setPhone({ value: cleaned, error: false, errorText: "Enter phone number", success: true });
              } else if (phoneDigits.length > 10) {
                setPhone({ value: cleaned, error: true, errorText: "Only 10 digits allowed", success: false });
              } else {
                setPhone({ value: cleaned, error: true, errorText: "Enter +1 followed by 10 digits", success: false });
              }
            }
          } else {
            const digits = value.replace(/\D/g, "");
            const formatted = formatPhoneNumber(value);
            if (digits.length === 10) {
              setPhone({ value: formatted, error: false, errorText: "Enter phone number", success: true });
            } else if (digits.length > 10) {
              setPhone({ value: formatted, error: true, errorText: "Only 10 digits allowed", success: false });
            } else if (digits.length > 0) {
              setPhone({ value: formatted, error: true, errorText: "Enter 10 digit phone number", success: false });
            } else {
              setPhone({ value: "", error: true, errorText: "Enter phone number", success: false });
            }
          }
        }
        break;
      }
      case "Email": {
        if (value && value.length) {
          if (EMAIL_REGEX_C360.test(value)) {
            setEmail({ value, error: false, errorText: "Enter email", success: true });
          } else {
            setEmail({ value, error: true, errorText: "Enter a valid email", success: false });
          }
        } else {
          setEmail({ value: "", error: true, errorText: "Enter email", success: false });
        }
        break;
      }
      case "newName": {
        if (value && value.length) {
          setNewName({ value, error: false, errorText: "Enter name", success: true });
        } else {
          setNewName({ value: "", error: true, errorText: "Enter name", success: false });
        }
        break;
      }
      case "newPhone": {
        if (isAutoPopulated) {
          if (value && value.length) {
            setNewPhone({ value, error: false, errorText: "Enter phone number", success: true });
          } else {
            setNewPhone({ value: "", error: true, errorText: "Enter phone number", success: false });
          }
        } else {
          const isIntlFormat = value.startsWith("+");
          if (isIntlFormat) {
            const rawDigits = value.replace(/[^0-9]/g, "");
            if (rawDigits.length === 0) {
              setNewPhone({ value: "+", error: true, errorText: "Enter +1 followed by 10 digits", success: false });
            } else {
              const forced = "1" + rawDigits.replace(/^1/, "");
              const cleaned = "+" + forced;
              const phoneDigits = forced.slice(1);
              if (phoneDigits.length === 10) {
                setNewPhone({ value: cleaned, error: false, errorText: "Enter phone number", success: true });
              } else if (phoneDigits.length > 10) {
                setNewPhone({ value: cleaned, error: true, errorText: "Only 10 digits allowed", success: false });
              } else {
                setNewPhone({ value: cleaned, error: true, errorText: "Enter +1 followed by 10 digits", success: false });
              }
            }
          } else {
            const digits = value.replace(/\D/g, "");
            const formatted = formatPhoneNumber(value);
            if (digits.length === 10) {
              setNewPhone({ value: formatted, error: false, errorText: "Enter phone number", success: true });
            } else if (digits.length > 10) {
              setNewPhone({ value: formatted, error: true, errorText: "Only 10 digits allowed", success: false });
            } else if (digits.length > 0) {
              setNewPhone({ value: formatted, error: true, errorText: "Enter 10 digit phone number", success: false });
            } else {
              setNewPhone({ value: "", error: true, errorText: "Enter phone number", success: false });
            }
          }
        }
        break;
      }
      case "newEmail": {
        if (value && value.length) {
          if (EMAIL_REGEX_C360.test(value)) {
            setNewEmail({ value, error: false, errorText: "Enter email", success: true });
          } else {
            setNewEmail({ value, error: true, errorText: "Enter a valid email", success: false });
          }
        } else {
          setNewEmail({ value: "", error: true, errorText: "Enter email", success: false });
        }
        break;
      }
      case "Quantity": {
        let numVal = parseInt(value);
        if (numVal > 0 && numVal <= pendingAssignment) {
          setQuantity({ value, error: false, errorText: "Enter quantity", success: true });
        } else {
          setQuantity({ value: "", error: true, errorText: `Enter quantity less than or equal to ${pendingAssignment}`, success: false });
        }
        break;
      }
    }
  };
  const handleClickOutside = () => {
    setNotification(null);
  };
  const clickRef = useOutsideClick(handleClickOutside);
  const notify = (content, type) => {
    setNotification(<SLNotification key={generate()} type={type} title={content} fullBleed={true} ref={clickRef} />);
  };
  const getVehicleSubscriptions = () => {
    const vehicleSubscriptions = [];
    const installTypeArr = [];
    Object.keys(productInfo).forEach((item) => {
      if (productInfo[item].featureType === "CORE") {
        installTypeArr.push(productInfo[item].InstallationType);
        vehicleSubscriptions.push({
          subscription: productInfo[item].SAPProductID,
          techRefId: productInfo[item].TechRefId,
          vehicleFeatures: [],
        });
      }
    });
    const installType = installTypeArr.some((type) => type === "VMI") ? "VMI" : installTypeArr.every((type) => type === "CMI") ? "CMI" : null;
    setInstallType(installType);
    setVehicleSubscriptions(vehicleSubscriptions);
  };
  useEffect(() => {
    if (cspDetails.cspDetails.cspData?.data?.data?.CSP.length > 0) {
      let cspContactDetails = cspDetails.cspDetails.cspData.data.data;
      handleFields("Name", cspContactDetails.CSP[0].CSPContactName);
      handleFields("Email", cspContactDetails.CSP[0].CSPContactEmail);
      handleFields("Phone", cspContactDetails.CSP[0].CSPContactPhone, true);
      handleFields("newName", cspContactDetails.CSP[0].CSPContactName);
      handleFields("newEmail", cspContactDetails.CSP[0].CSPContactEmail);
      handleFields("newPhone", cspContactDetails.CSP[0].CSPContactPhone, true);
    } else {
      let cspContactDetails = cspDetails.cspDetails.cspData.data.data;
      handleFields("Name", cspContactDetails.CASEDetails[0].CSPContactName);
      handleFields("Email", cspContactDetails.CASEDetails[0].CSPContactEmail);
      handleFields("Phone", cspContactDetails.CASEDetails[0].CSPContactPhone, true);
      handleFields("newName", cspContactDetails.CASEDetails[0].CSPContactName);
      handleFields("newEmail", cspContactDetails.CASEDetails[0].CSPContactEmail);
      handleFields("newPhone", cspContactDetails.CASEDetails[0].CSPContactPhone, true);
    }
    const data = productInfo
      .map((item) => item.Feature)
      .reduce((prev, curr) => {
        if (curr?.length > 0) {
          return [prev, ", ", curr];
        } else {
          return [prev, "", curr];
        }
      });
    setFeatureValues(data);
    setPendingAssignment(props.availableQty);
    getVehicleSubscriptions();
    document.getElementById("RightSectionContainer")?.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  useEffect(() => {
    if (!sameAsShipping) {
      if (
        address.verified &&
        name.success &&
        phone.success &&
        email.success &&
        quantity.success &&
        newAddress.verified &&
        newName.success &&
        newPhone.success &&
        newEmail.success
      ) {
        setSaveDisabled(false);
      } else {
        setSaveDisabled(true);
      }
    } else {
      if (address.verified && name.success && phone.success && email.success && quantity.success) {
        setSaveDisabled(false);
      } else {
        setSaveDisabled(true);
      }
    }
  }, [
    address.verified,
    name.success,
    phone.success,
    email.success,
    quantity.success,
    newAddress.verified,
    newName.success,
    newPhone.success,
    newEmail.success,
    sameAsShipping,
  ]);
  const handleCancelClick = () => {
    switchTab(1);
  };
  const handleSaveClick = async () => {
    setLoader(true);
    let payload = {
      vinList: [
        {
          vin: null,
          year: null,
          make: null,
          model: null,
          fuelType: null,
          killSwitch: null,
          emergency: null,
          whhelChair: null,
          weightClass: null,
          quantity: quantity.value,
        },
      ],
      registrationNumber: "",
      accountId: cspDetails.cspDetails.accountId,
      type: "ASSET",
      vehicleAssetName: "",
      shippingAddress: {
        address1: address.address1.value,
        address2: address.address2.value,
        city: address.city.value,
        country: address.country.value.description,
        countryCode: address.country.value.code,
        stateCode: address.state.value.erpStateCode,
        zipCode: address.zip.value,
        timezone: address.timezone,
        addressByPass: address.addressByPass,
        locationFound: address.locationFound,
        locusLocationId: address.locusLocationId,
        dpv: address.dpv,
        dpvDetails: address.dpvDetail,
        locusSuggestedAddress: address.locusSuggestedAddress,
        latitude: address.latitude,
        longitude: address.longitude,
      },
      contactInfo: {
        customerName: name.value,
        customerEmail: email.value,
        customerPhone: phone.value,
      },
      isInstallationAddressSameAsShipping: sameAsShipping,
      installationAddress: sameAsShipping
        ? null
        : {
            address1: newAddress.address1.value,
            address2: newAddress.address2.value,
            city: newAddress.city.value,
            country: newAddress.country.value.description,
            countryCode: newAddress.country.value.code,
            stateCode: newAddress.state.value.erpStateCode,
            zipCode: newAddress.zip.value,
            timezone: newAddress.timezone,
            addressByPass: newAddress.addressByPass,
            locationFound: newAddress.locationFound,
            locusLocationId: newAddress.locusLocationId,
            dpv: newAddress.dpv,
            dpvDetails: newAddress.dpvDetail,
            locusSuggestedAddress: newAddress.locusSuggestedAddress,
            latitude: newAddress.latitude,
            longitude: newAddress.longitude,
          },
      installationContactInfo: sameAsShipping
        ? null
        : {
            customerName: newName.value,
            customerEmail: newEmail.value,
            customerPhone: newPhone.value,
          },
      createdBy: `${cspDetails.cspDetails.firstName} ${cspDetails.cspDetails.lastName}`,
      sourceApplication: "C360",
      crmRefId: workTicketInfo.workTicketInfo.crmRefId,
      salesOrgId: cspDetails.cspDetails.cspData.data.data.CSP[0].Opp_Sales_Org,
      bundleId: productInfo[0].BundleId,
      bundleOrderType: productInfo[0].OrderDetailType,
      productPlatform: cspDetails.cspDetails.cspData.data.data.ProductPlatform,
      accountBrand: cspDetails.cspDetails.cspData.data.data.Account_Brand,
      installType: installType,
      vehicleSubscriptions: vehicleSubscriptions,
    };
    let response = await saveVin(payload);
    if (response && response.status === 200) {
      switchTab(1);
    } else {
      notify("Error saving Asset", "error");
    }
    setLoader(false);
  };

  const handleCheckboxChange = () => {
    setSameAsShipping((prev) => !prev);

    setNewAddress({
      verified: false,
      addressByPass: null,
      locationFound: null,
      timezone: "",
      latitude: "",
      longitude: "",
      locusSuggestedAddress: "",
      historicalAddress: { value: "", error: false, errorText: "", success: false },
      address1: { value: "", error: false, errorText: "Enter valid street address", success: false },
      address2: { value: "", error: false, errorText: "Enter address 2", success: false },
      city: { value: "", error: false, errorText: "Enter city", success: false },
      country: { value: null, options: [], error: false, errorText: "Please select country", success: false },
      state: { value: null, options: [], allStateOptions: null, error: false, errorText: "Please select state", success: false },
      zip: { value: "", error: false, errorText: "Enter zip code", success: false },
    });
  };

  const renderVMISection = () => {
    return (
      <SLGridLayout>
        <SLRowLayout css={{ paddingLeft: "10px !important" }}>
          <UltraMediumText css={{ marginTop: "1.25rem" }} eDSFont fontSize="18px" marginBottom="0.7rem">
            Installation Address
          </UltraMediumText>
        </SLRowLayout>
        <SLRowLayout css={{ paddingLeft: "10px !important", marginTop: "0.5rem" }}>
          <CheckboxWrapper>
            <CheckboxGroup
              data={[
                {
                  name: "sameAsShipping",
                  label: "Installation Address is the same as shipping",
                  value: "sameAsShipping",
                  selected: sameAsShipping,
                  disabled: !address.verified,
                },
              ]}
              onChange={() => handleCheckboxChange()}
            />
          </CheckboxWrapper>
        </SLRowLayout>
        {!sameAsShipping ? (
          <>
            <ValidateInstallationAddress
              address={newAddress}
              setAddress={setNewAddress}
              showHistoricalAddressDropdown={true}
              setLoader={setLoader}
              variant="vehicle"
              showTitle={false}
              showTypedAddressOption={false}
              defaultCountryOnNew="USA"
              trackLocusFields={true}
              styles={{ radioGroupWidth: "100%" }}
            />
            <SLGridLayout>
              <SLRowLayout css={{ marginTop: "1.25rem", paddingLeft: "10px !important" }}>
                <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 6 }}>
                  <CustomInput
                    width="100%"
                    type="text"
                    label="Contact Name*"
                    aria-label="Contact Name"
                    error={newName.error}
                    errorText={newName.errorText}
                    success={newName.success}
                    value={newName.value}
                    maxLength={50}
                    css={{ paddingRight: "10px" }}
                    onChange={(event) => handleFields("newName", event.target.value, "")}
                  />
                </CompactCol>
                <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 6 }}>
                  <CustomInput
                    width="100%"
                    type="text"
                    label="Phone*"
                    aria-label="Phone"
                    maxLength={16}
                    error={newPhone.error}
                    errorText={newPhone.errorText}
                    success={newPhone.success}
                    value={newPhone.value}
                    onChange={(event) => handleFields("newPhone", event.target.value)}
                  />
                </CompactCol>
              </SLRowLayout>
              <SLRowLayout css={{ paddingLeft: "10px !important" }}>
                <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
                  <CustomInput
                    width="100%"
                    type="text"
                    label="Email*"
                    aria-label="Email"
                    error={newEmail.error}
                    errorText={newEmail.errorText}
                    success={newEmail.success}
                    value={newEmail.value}
                    onChange={(event) => handleFields("newEmail", event.target.value, "")}
                  />
                </CompactCol>
              </SLRowLayout>
            </SLGridLayout>
          </>
        ) : (
          <></>
        )}
      </SLGridLayout>
    );
  };

  if (!productInfo || productInfo.length === 0) return null;

  return (
    <div>
      {notification}
      <Loader active={isLoading} fullscreen />
      <Title level={3} style={{ marginTop: "0px" }}>
        {productInfo[0]?.BundleName}
      </Title>
      <SmallText>{featureValues}</SmallText>
      <SmallText>{pendingAssignment} Vehicles Pending Assignment</SmallText>
      <div css={HistoricalAddressRow}>
        <div style={{ pointerEvents: !sameAsShipping ? "none" : "auto", opacity: !sameAsShipping ? 0.5 : 1 }}>
          <CommonValidateAddress
            address={address}
            setAddress={setAddress}
            showHistoricalAddressDropdown={true}
            setLoader={setLoader}
            variant="vehicle"
            showTitle={true}
            showTypedAddressOption={false}
            defaultCountryOnNew="USA"
            trackLocusFields={true}
            styles={{ containerWidth: "97%", radioGroupWidth: "100%" }}
          />
        </div>
        <SLGridLayout>
          <SLRowLayout css={{ marginTop: "1.25rem", paddingLeft: "10px !important" }}>
            <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 6 }}>
              <CustomInput
                width="100%"
                type="text"
                label="Contact Name*"
                aria-label="Contact Name"
                error={name.error}
                errorText={name.errorText}
                success={name.success}
                value={name.value}
                maxLength={50}
                css={{ paddingRight: "10px" }}
                disabled={!sameAsShipping}
                onChange={(event) => handleFields("Name", event.target.value, "")}
              />
            </CompactCol>
            <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 6 }}>
              <CustomInput
                width="100%"
                type="text"
                label="Phone*"
                aria-label="Phone"
                maxLength={16}
                error={phone.error}
                errorText={phone.errorText}
                success={phone.success}
                value={phone.value}
                disabled={!sameAsShipping}
                onChange={(event) => handleFields("Phone", event.target.value)}
              />
            </CompactCol>
          </SLRowLayout>
          <SLRowLayout css={{ paddingLeft: "10px !important" }}>
            <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
              <CustomInput
                width="100%"
                type="text"
                label="Email*"
                aria-label="Email"
                error={email.error}
                errorText={email.errorText}
                success={email.success}
                value={email.value}
                disabled={!sameAsShipping}
                onChange={(event) => handleFields("Email", event.target.value, "")}
              />
            </CompactCol>
          </SLRowLayout>
        </SLGridLayout>
        {props.productInfo[0]?.ProductName.toLowerCase().includes("non") && props.productInfo[0]?.ProductName.toLowerCase().includes("powered ")
          ? null
          : installType === "VMI" && renderVMISection()}
        <SLGridLayout>
          <SLRowLayout css={{ marginTop: "1.25rem", paddingLeft: "10px !important" }}>
            <CompactCol colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
              <CustomInput
                width="100%"
                type="text"
                label="Quantity*"
                aria-label="Quantity"
                error={quantity.error}
                errorText={quantity.errorText}
                success={quantity.success}
                value={quantity.value}
                onChange={(event) => handleFields("Quantity", event.target.value, "")}
              />
            </CompactCol>
          </SLRowLayout>
        </SLGridLayout>
      </div>
      <FlexRow style={{ marginTop: "2rem" }}>
        <Button style={{ backgroundColor: "#fff", color: "#000" }} role="button" size="small" aria-label="cancelButton" onClick={handleCancelClick}>
          Cancel
        </Button>
        <Button
          style={{ marginLeft: "1rem" }}
          role="button"
          size="small"
          aria-label="saveButton"
          disabled={saveDisabled}
          ariaDisabled={saveDisabled}
          onClick={handleSaveClick}
        >
          Save
        </Button>
      </FlexRow>
    </div>
  );
}

export const AddAssetAssignmentMetadata = {
  name: "Add Asset Assignment",
  id: "Add_Asset_Assignment",
  component: lazy(() => import("./AddAssetAssignment")),
  route: "/connect360/add-asset-assignment",
};
